<script>
  export default {
    name: 'Services',
    data() {
      return {
        slides: [
          {
            img: '8.png',
            text: 'Productos con demanda creciente por la nueva normalidad de higiene',
          },
          {
            img: '5.png',
            text: 'Sencillo de administrar ya que cuenta con un proveedor centralizado',
          },
          {
            img: '1.png',
            text: 'Atención personalizada con asesoramiento de profesionales         ',
          },
          {
            img: '3.png',
            text: 'Responsables designados para la atención de cada franquiciado     ',
          },
          {
            img: '7.png',
            text: 'Locales manejados por un número muy bajo de capital humano        ',
          },
          {
            img: '6.png',
            text: 'Alta capacidad de crecimiento en su producción                    ',
          },
          {
            img: '10.png',
            text:
              'Protección legal necesaria para el funcionamiento del sistema de franquicias DIU',
          },
          {
            img: '9.png',
            text:
              'Software especializado para el manejo de facturación, control de stock y demás módulos para su adecuada gestión',
          },
          {
            img: '2.png',
            text: 'Marca con mayor antigüedad en el mercado y gran reconocimiento      ',
          },
          {
            img: '11.png',
            text:
              'Variedad de productos con calidad y precios que provienen directo de la industria',
          },
          {
            img: '12.png',
            text: 'Recupero de inversión entre 12 y 18 meses',
          },
        ],
        swiperOption: {
          slidesPerView: 3,
          spaceBetween: 30,
          // centeredSlides: true,
          centerInsufficientSlides: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            1280: {
              slidesPerView: 4,
              // spaceBetween: 20,
            },
            991: {
              slidesPerView: 3,
              // spaceBetween: 20,
            },
            576: {
              slidesPerView: 2,
              // spaceBetween: 20,
            },
            320: {
              slidesPerView: 1,
              // spaceBetween: 50,
            },
          },
        },
      }
    },
  }
</script>

<template>
  <div>
    <!--START SERVICES-->
    <section class="section bg-light" id="services">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">¿Qué te ofrece nuestra franquicia?</h1>
          <div class="section-title-border my-3"></div>
        </div>
      </div>
      <swiper class="swiper container px-5" :options="swiperOption">
        <swiper-slide class="" v-for="(item, index) in slides" :key="index">
          <b-card
            :img-src="'team/' + item.img"
            img-alt="Image"
            img-top
            tag="article"
            v-if="item.img != '' && item.text != ''"
          >
            <b-card-text class="text-center">
              <h4 v-html="item.text">
                <!-- {{ item.text }} -->
              </h4>
            </b-card-text>
          </b-card>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </section>
    <!--START SERVICES-->

    <!--START WEBSITE-DESCRIPTION-->
    <section
      class="section bg-web-desc"
      :style="{
        'background-image': 'url(' + require('@/assets/images/banner.5.png') + ')',
        'background-size': 'cover',
        'background-position': 'center',
      }"
    >
      <div class="bg-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h1 class="text-white"
              >Expandimos nuestro negocio a TODO Uruguay <br />¿Quieres ser parte de la exitosa red de franquicias DIU?</h1
            >
            <p class="padding-t-15 home-desc mx-auto"
              >Si te encuentras en las principales ciudades del país y estás buscando tu
                oportunidad de inversión, este negocio es para ti</p
            >
            <a href="#contact" class="btn btn-bg-white margin-t-30">Solicita tu franquicia</a>
          </div>
        </div>
      </div>
    </section>
    <!--END WEBSITE-DESCRIPTION-->
  </div>
</template>

<style scoped>
  .swiper-button-prev,
  .swiper-button-next {
    color: #16047c;
  }
  .card-body.card-body {
    padding: 1rem;
  }

  @media only screen and (min-width: 1281px) {
    .card-body.card-body {
      height: 170px;
    }
  }
  @media only screen and (max-width: 1280px) {
    .card-body.card-body {
      height: 148px;
    }
  }
  @media only screen and (max-width: 991px) {
    .card-body.card-body {
      height: 148px;
    }
  }
  @media only screen and (max-width: 768px) {
    .card-body.card-body {
      height: 192px;
    }
  }
  @media only screen and (max-width: 575px) {
    .card-body.card-body {
      height: 148px;
    }
  }
</style>
